import { useFormik } from "formik";
import * as Yup from "yup";
import ModalComponent from "..";
import { useCancelEventMutation } from "../../../redux/features/event/event.api";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import { ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { Icon } from "../../icon/icon";
import { TextInput } from "../../inputs/textInput";
import { MiniHeader } from "../../typography/miniHeader";

export const CancelEventModal = ({
  open,
  handleClose,
  event,
  onSuccess,
}: ModalCompProps & {
  event: CreatedEvent;
  onSuccess: () => void;
}) => {
  const [cancelEvent, { isLoading }] = useCancelEventMutation();

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    resetForm,
  } = useFormik({
    initialValues: {
      name: "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("Please enter the event name below to confirm deletion")
        .test(
          "is-event-name",
          "Event name does not match.",
          (value) => value?.toLowerCase() === event.name.toLowerCase(),
        ),
    }),
    onSubmit: async () => {
      const resp = await cancelEvent({
        id: event._id,
      });

      if (resp?.data?.status === "success") {
        onSuccess();
        resetForm();
      }
    },
  });

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
        resetForm();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader={false}
      title={undefined}
      subtitle={undefined}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Icon
          svg={"calendar-off"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px] text-danger"
        />

        <div>
          <MiniHeader
            header={`Cancel “${event.name}”`}
            subheader="You’re about to cancel this event and it cannot be undone. If there are any registered guests, we will notify them that the event has been canceled. Please enter the event name below to confirm event cancellation."
          />
        </div>

        <TextInput
          type="text"
          value={values.name}
          hasTitle
          title="Event Name"
          placeholder=""
          onBlur={handleBlur}
          onChange={handleChange}
          name="name"
          readOnly={false}
          errors={touched.name && errors.name ? errors.name : undefined}
        />

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
              resetForm();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Cancel Event"}
            type="submit"
            onClick={() => {}}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"danger"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
